import { ValueGetterParams } from '@ag-grid-community/core';
import { AgGridColumnDef } from '@tassat/common-definitions';
import { FirmRecord, UserRecord } from '@tassat/fred-definitions';
import { WalletRecordExtended } from '@tassat/fred-extended-definitions';

import { IFeaturesContext } from 'SharedComponents/hooks/useFeatures';

const statusComparator = (userRecord1: UserRecord, userRecord2: UserRecord): number => {
    return ((userRecord1.IsLocked || userRecord1.IsFrozen) === (userRecord2.IsLocked ||
        userRecord2.IsFrozen)) ? 0 : (userRecord1.IsLocked || userRecord1.IsFrozen) ? 1 : -1;
};

const statusFilterValueGetter = (params: ValueGetterParams): string => {
    const userRecord: UserRecord = params.data.user;

    return userRecord.IsLocked ? 'Locked' : userRecord.IsFrozen ? 'Frozen' : 'Active';
};

export const firmWalletUsersColumnDefs: (firm: Pick<FirmRecord, 'FirmId'>, features: IFeaturesContext, account: WalletRecordExtended) => AgGridColumnDef[] = (firm: Pick<FirmRecord, 'FirmId'>, features: IFeaturesContext, account: WalletRecordExtended) => {
    const defaultColumnDefs: AgGridColumnDef[] = [
        {
            field: 'user.Email',
            headerName: 'User',
            headerValueGetter: (params) => (params.api.getDisplayedRowCount() ? `${params.api.getDisplayedRowCount()} User${params.api.getDisplayedRowCount() !== 1 ? 's' : ''}` : 'Users'),
            cellRenderer: 'userCellRenderer',
            minWidth: 100,
            menuTabs: ['filterMenuTab'],
            flex: 2
        },
        {
            field: 'user',
            headerName: 'Status',
            filterValueGetter: statusFilterValueGetter,
            cellRenderer: 'userStatusCellRenderer',
            minWidth: 120,
            menuTabs: ['filterMenuTab'],
            comparator: statusComparator,
            flex: 1
        },
        {
            field: 'userAccount.ClientRoleId',
            headerName: 'Role',
            cellRenderer: 'userAccountRoleRenderer',
            cellRendererParams: { firmId: firm?.FirmId },
            menuTabs: [],
            minWidth: 120,
            valueGetter: ({ data }) => ({
                IsSCEnabled: data.userAccount.IsSCEnabled,
                ClientRoleId: data.userAccount.ClientRoleId
            }),
            flex: 1
        },
        {
            field: 'actions',
            headerName: 'Actions',
            headerClass: 'rightAligned',
            cellClass: 'rightAlignedCell',
            cellRenderer: 'actionButtonsCellRenderer',
            width: 100,
            menuTabs: []
        }
    ];

    return defaultColumnDefs;
};

export const readonlyFirmWalletUsersColumnDefs: (firm: Pick<FirmRecord, 'FirmId'>, features: IFeaturesContext) => AgGridColumnDef[] = (firm: Pick<FirmRecord, 'FirmId'>, features: IFeaturesContext) => {
    const defaultColumnDefs: AgGridColumnDef[] = [
        {
            field: 'user.Email',
            headerName: 'User',
            headerValueGetter: (params) => (params.api.getDisplayedRowCount() ? `${params.api.getDisplayedRowCount()} User${params.api.getDisplayedRowCount() !== 1 ? 's' : ''}` : 'Users'),
            cellRenderer: 'userCellRenderer',
            minWidth: 100,
            menuTabs: ['filterMenuTab'],
            flex: 2
        },
        {
            field: 'user',
            headerName: 'Status',
            filterValueGetter: statusFilterValueGetter,
            cellRenderer: 'userStatusCellRenderer',
            minWidth: 120,
            menuTabs: ['filterMenuTab'],
            comparator: statusComparator,
            flex: 1
        },
        {
            field: 'userAccount.ClientRoleId',
            headerName: 'Role',
            cellRenderer: 'userAccountRoleRenderer',
            cellRendererParams: { firmId: firm?.FirmId },
            menuTabs: [],
            minWidth: 120,
            valueGetter: ({ data }) => ({
                IsSCEnabled: data.userAccount.IsSCEnabled,
                ClientRoleId: data.userAccount.ClientRoleId
            }),
            flex: 1
        }
    ];

    return defaultColumnDefs;
};